import * as React from 'react';
import {SimpleModal, useSimpleModalRequestClose} from 'Src/components/SimpleModal/SimpleModal';
import {Switch} from 'Src/components/Switch/Switch';
import {Loader} from 'Src/components/Loader/Loader';
import {highLevelApi, errorMessage} from 'Src/helpers/service/adminSU/highLevelTournament';

function CloseSettings({disabled}: any) {
  const requestClose = useSimpleModalRequestClose();
  return <button type="button" className="tnBtn tnBtnSecondary" disabled={disabled} onClick={requestClose}>Close</button>;
}
const key = row => `${row.userId}:${row.permissionId}`;
export function ParticipantNotificationSettings({user, tournamentId, onClose}: any) {
  const [data, setData] = React.useState<any>(null);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [enabled, setEnabled] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');
  const [saved, setSaved] = React.useState(false);
  React.useEffect(() => {
    let active = true;
    highLevelApi(user, tournamentId, 'notificationSettings').then(result => {
      if (!active) return;
      setData(result); setSelected(result.admins.map(key)); setEnabled(result.useAdminsForNotifications);
    }).catch(e => {if (active) setError(errorMessage(e));});
    return () => {active = false;};
  }, [tournamentId, user.activeSchoolId]);
  const dirty = data && (enabled !== data.useAdminsForNotifications || [...selected].sort().join() !== data.admins.map(key).sort().join());
  const toggle = id => setSelected(values => values.includes(id) ? values.filter(value => value !== id) : [...values, id]);
  const availableKeys = new Set((data?.availableAdmins || []).map(key));
  const invalidSelection = selected.some(id => !availableKeys.has(id));
  const save = async () => {
    setSaving(true); setError(''); setSaved(false);
    try {
      const result = await highLevelApi(user, tournamentId, 'notificationSettings', {
        useAdminsForNotifications: enabled,
        admins: selected.map(value => {const [userId, permissionId] = value.split(':'); return {userId, permissionId};})
      });
      setData(result); setSelected(result.admins.map(key)); setSaved(true);
    } catch (e) {setError(e?.response?.data?.details?.text || errorMessage(e));}
    finally {setSaving(false);}
  };
  return <SimpleModal isOpen title="Availability notification recipients" customClass="hltStudentAllocationModal tpNotificationSettings"
    dialogStyle={{maxWidth: 600}} isBodyBold={false} showFooter={false} guardUnsavedChanges={Boolean(dirty)} onCloseIconClick={() => {if (!saving) onClose();}}>
    <div className="hltStudentAllocationForm">
      <div className="hltStudentAllocationForm__content">
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        {saved && <div className="alert alert-success" role="status">Notification recipients saved.</div>}
        {!data && !error && <Loader />}
        {data && <fieldset className="tpNotificationSettings__fields" disabled={saving}>
          <p>Choose who receives school availability responses for this tournament in <strong>{user.activeSchool?.name || user.activeSchoolName || 'your participating union'}</strong>.</p>
          <Switch name="useAdminsForNotifications" label="Use admins list for notifications" checked={enabled} disabled={saving}
            onChange={e => {setEnabled(e.target.checked); setSaved(false);}} />
          <p className="tpNotificationSettings__hint">{enabled ? 'Only selected administrators of your participating union will receive these notifications.' : 'All active administrators and managers of your participating union will receive these notifications.'}</p>
          <label className="tpNotificationSettings__search">Search administrators<input type="search" value={search} onChange={e => setSearch(e.target.value)} placeholder="Name…" /></label>
          <div className="tpNotificationSettings__list">{data.availableAdmins.filter(admin => `${admin.firstName || ''} ${admin.lastName || ''}`.toLowerCase().includes(search.toLowerCase())).map(admin =>
            <label className="tpNotificationSettings__admin" key={key(admin)}><input type="checkbox" checked={selected.includes(key(admin))} onChange={() => {toggle(key(admin)); setSaved(false);}} />
              <span><strong>{`${admin.firstName || ''} ${admin.lastName || ''}`.trim() || 'Administrator'}</strong><small>Union administrator</small></span>
            </label>)}
            {!data.availableAdmins.length && <p>No active union administrators found.</p>}
          </div>
          {invalidSelection && <p className="tpNotificationSettings__hint">Some selected administrators no longer have an active role in your union. <button type="button" className="tpNotificationSettings__clear" onClick={() => setSelected(values => values.filter(value => availableKeys.has(value)))}>Remove inactive selections</button></p>}
          {enabled && !selected.length && <p className="tpNotificationSettings__hint">Select at least one administrator before saving.</p>}
        </fieldset>}
      </div>
      <footer className="hltStudentAllocationForm__footer"><span>{selected.length} selected</span><div>
        <CloseSettings disabled={saving} />
        <button type="button" className="tnBtn tnBtnPrimary" disabled={saving || !data || !dirty || invalidSelection || (enabled && !selected.length)} onClick={save}>{saving ? 'Saving…' : 'Save settings'}</button>
      </div></footer>
    </div>
  </SimpleModal>;
}
